module.exports = "/_next/static/images/1c0217ca8cf734ebe1e4c9e4189992ce-features-meal-xs.jpg";